import { isFuture, parseISO } from "date-fns";

export function isShiftPriorityValid(priorityTill: string): boolean {
  return isFuture(parseISO(priorityTill));
}
